import { posix } from "path";
function toServerOutputPath(input, outDir) {
  var normalized = input.replace(/\\/g, "/");
  var prefix = `${outDir}/server/`;
  if (normalized === `${outDir}/server` || normalized.startsWith(prefix)) {
    return normalized;
  }
  return posix.join(outDir, "server", normalized);
}
export {
  toServerOutputPath
};
//# sourceMappingURL=toServerOutputPath.js.map
